import { Card, Col, Container, Row, Table } from "react-bootstrap";

import AnalyticsIcon from "@mui/icons-material/Analytics";
import { BarChart } from "@mui/x-charts/BarChart";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { Chip } from "@mui/material";
import DashboardCard from "../components/Admin/Reusable/DashboardCard";
import FeedIcon from "@mui/icons-material/Feed";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import { Link } from "react-router-dom";
import { PieChart } from "@mui/x-charts/PieChart";
import React, { useEffect, useState } from "react";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  fetchDashboarData,
  fetchDashboarDataMore,
  fetchDashboardDataBestSale,
  fetchDashboardDataProduct,
  fetchDashboardDataReward,
  fetchDashboardDataTask,
} from "../actions/user";
import LineChartComponent from "../components/Admin/Reusable/LineChartComponent";

const Dashboard = () => {
  const loggedUserReducer = useSelector((state) => state.loggedUserReducer);
  const {
    dashboardData,
    dashboardDataMore,
    dashboardDataTask,
    dashboardDataReward,
    dashboardDataProduct,
    dashboardDataBestSale,
  } = useSelector((state) => state.userReducer);

  const [chartData, setChartData] = useState({
    pDataAktivni: [],
    pDataNeaktivni: [],
    xLabels: [],
    seriesData: [],
    xLabels2: [],
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchDashboarData());
    dispatch(fetchDashboarDataMore());
    dispatch(fetchDashboardDataTask());
    dispatch(fetchDashboardDataReward());
    dispatch(fetchDashboardDataProduct());
    dispatch(fetchDashboardDataBestSale());
  }, [dispatch]);

  useEffect(() => {
    // Transformiši podatke u format koji BarChart očekuje
    const pDataAktivni = dashboardDataMore.map((item) => item.activeCount);
    const pDataNeaktivni = dashboardDataMore.map((item) => item.inactiveCount);
    const xLabels = dashboardDataMore.map((item) => item.countryName);

    setChartData({
      pDataAktivni,
      pDataNeaktivni,
      xLabels,
    });
  }, [dashboardDataMore]);

  const chartSetting = {
    xAxis: [
      {
        label: "Ukupan broj",
      },
    ],
    height: 615,
  };

  return (
    <div className="dashboard-content-holder">
      <Breadcrumb title={"Dashboard"} type={"dashboard"} />
      <Container className="mt-3">
        <Row>
          <Col lg={12}>
            <h4 className="fs-16 mb-1">
              Dobrodošli, {loggedUserReducer?.loggedUser?.name}{" "}
              {loggedUserReducer?.loggedUser?.lastName}!
            </h4>
            <p className="text-muted mb-0">
              Pogledajte aktuelne informacije i ostanite u toku sa svim
              dešavanjima.
            </p>
          </Col>
        </Row>
        <Row className="dashboard-cards-holder mt-3">
          <Col lg={8}>
            <Row>
              <Col lg={4}>
                <DashboardCard
                  number={dashboardDataProduct?.productCount || 0}
                  color={"green-icon"}
                  icon={<ShowChartIcon />}
                  title={`Ukupno aktivinih proizvoda`}
                  link={"/product-list"}
                  linkName={"Pregled proizvoda"}
                />
              </Col>
              <Col lg={4}>
                <DashboardCard
                  number={dashboardDataTask?.taskCount || 0}
                  color={"blue-icon"}
                  icon={<AnalyticsIcon />}
                  title={`Ukupno kreiranih zadataka`}
                  link={"/task-list"}
                  linkName={"Pregled zadataka"}
                />
              </Col>
              <Col lg={4}>
                <DashboardCard
                  number={dashboardDataReward?.rewardCount || 0}
                  color={"yellow-icon"}
                  icon={<LeaderboardIcon />}
                  title={`Ukupno kreiranih nagrada`}
                  link={"/award-list"}
                  linkName={"Pregled nagrada"}
                />
              </Col>
              <Col lg={12} className="dashboard-card">
                <Card>
                  <Card.Header className="border-bottom-0">
                    <Card.Title>
                      <small className="text-muted">Prodavci</small>
                    </Card.Title>
                  </Card.Header>
                  <Card.Header className="bg-light-subtle p-0 border-bottom-0">
                    <Row className="g-0">
                      <Col lg={3} md={6} sm={6} xs={6}>
                        <div className="dashboard-card-information-item text-center">
                          <h5 class="mb-1">
                            <span class="counter-value" data-target="7585">
                              {dashboardData?.allAccounts || 0}
                            </span>
                          </h5>
                          <p class="text-muted mb-0">Registrovani prodavci</p>
                        </div>
                      </Col>
                      <Col lg={3} md={6} sm={6} xs={6}>
                        <div className="dashboard-card-information-item text-center">
                          <h5 class="mb-1">
                            <span class="counter-value" data-target="7585">
                              {dashboardData?.activeAccounts || 0}
                            </span>
                          </h5>
                          <p class="text-muted mb-0">Aktivni prodavci</p>
                        </div>
                      </Col>
                      <Col lg={3} md={6} sm={6} xs={6}>
                        <div className="dashboard-card-information-item text-center">
                          <h5 class="mb-1">
                            <span class="counter-value" data-target="7585">
                              {dashboardData?.inactiveAccounts || 0}
                            </span>
                          </h5>
                          <p class="text-muted mb-0">Neaktivni prodavci</p>
                        </div>
                      </Col>
                      <Col lg={3} md={6} sm={6} xs={6}>
                        <div className="dashboard-card-information-item text-center">
                          <h5 class="mb-1">
                            <span
                              class="counter-value success-color"
                              data-target="7585"
                            >
                              {dashboardData?.newThisMonthAccounts || 0}
                            </span>
                          </h5>
                          <p class="text-muted mb-0">Novi prodavci u mesecu</p>
                        </div>
                      </Col>
                    </Row>
                  </Card.Header>
                  <Card.Body>
                    <BarChart
                      colors={["#4CAF50", "#FF5733"]} // zelena za aktivne, crvena za neaktivne
                      height={375}
                      series={[
                        {
                          data: chartData.pDataAktivni,
                          label: "Aktivni prodavci",
                          id: "activeUsers",
                        },
                        {
                          data: chartData.pDataNeaktivni,
                          label: "Neaktivni prodavci",
                          id: "inactiveUsers",
                        },
                      ]}
                      xAxis={[{ data: chartData.xLabels, scaleType: "band" }]}
                    />
                    {/* <BarChart
                      colors={["#c11f43"]}
                      height={375}
                      series={[
                        {
                          data: pDataAktivni,
                          label: "Broj registrovanih korisnika",
                          id: "pvId",
                        },
                      ]}
                      xAxis={[{ data: xLabels, scaleType: "band" }]}
                    /> */}
                  </Card.Body>
                  <Card.Footer>
                    <small className="text-muted">
                      <Link to={"/customer-list"}>
                        Pogledaj listu prodavaca
                      </Link>
                    </small>
                  </Card.Footer>
                </Card>
              </Col>
            </Row>
          </Col>
          <Col lg={4}>
            <Card>
              <Card.Header>
                <Card.Title>
                  <small className="text-muted">Najprodavaniji proizvodi</small>
                </Card.Title>
              </Card.Header>
              <Card.Body>
                <BarChart
                  colors={["#c11f43"]}
                  margin={{ left: 130 }}
                  dataset={dashboardDataBestSale}
                  yAxis={[
                    {
                      scaleType: "band",
                      dataKey: "productName",
                      valueFormatter: (code, context) =>
                        context.location === "tick"
                          ? code
                          : `${code}
                           (${
                             dashboardDataBestSale.find(
                               (d) => d.productName === code
                             )?.countryName
                           })`,
                    },
                  ]}
                  series={[
                    {
                      dataKey: "quantity",
                      label: "Ukupan broj prodatih jedinica",
                    },
                  ]}
                  layout="horizontal"
                  {...chartSetting}
                />
              </Card.Body>
              <Card.Footer>
                <small className="text-muted">
                  <Link to={"/product-list"}>Pogledaj sve proizvode</Link>
                </small>
              </Card.Footer>
            </Card>
          </Col>

          <Col lg={12}>
            <Card>
              <Card.Header>
                <Card.Title>
                  <small className="text-muted">
                    Prijava prodaje po mesecima
                  </small>
                </Card.Title>
              </Card.Header>
              <Card.Body>
                <LineChartComponent />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Dashboard;
